import { createFileRoute } from "@tanstack/react-router"
import { getUseCaseBySlug } from "@/data/use-cases/use-cases-registry"
import { getUseCaseBySlugForLanguage } from "@/data/use-cases/use-cases-i18n"
import { useTranslation } from "@/lib/i18n"
import UseCasePageLayout from "@/components/use-cases/UseCasePageLayout"

const fallback = getUseCaseBySlug("instagram-dm-email-collection")!

export const Route = createFileRoute("/$lang/use-case/instagram-dm-email-collection")({
  component: LangCollectEmailsPage,
})

function LangCollectEmailsPage() {
  const { language } = useTranslation()
  const data = getUseCaseBySlugForLanguage(language, "instagram-dm-email-collection") || fallback
  return <UseCasePageLayout data={data} />
}
